(function () {
  const fallbackCoupon = "EXTRA10";

  // Erkenne deinen CTA-Button über Button-Text
  const CTA_TEXT_MATCH = ["angebot sichern", "jetzt 10€ sparen"];

  function normalize(s) {
    return (s || "").toString().trim().toLowerCase();
  }

  function isCtaButton(el) {
    const t = normalize(el.textContent);
    return CTA_TEXT_MATCH.some((x) => t.includes(normalize(x)));
  }

  function findCouponInPopup(popupRoot) {
    if (!popupRoot) return null;

    // Sucht ein Token wie EXTRA10 im Popup-Text
    const text = popupRoot.innerText || "";
    const match = text.match(/\b[A-Z0-9]{4,}\b/);
    if (match) return match[0];

    // Optional: wenn du später ein data-coupon o.Ä. nutzt
    const codeEl = popupRoot.querySelector("[data-coupon], .coupon, .discount-code, .code");
    if (codeEl) return (codeEl.getAttribute("data-coupon") || codeEl.textContent || "").trim();

    return null;
  }

  async function copyToClipboard(str) {
    const text = (str || "").trim();
    if (!text) return false;

    try {
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(text);
        return true;
      }
    } catch (e) {}

    // Fallback
    try {
      const ta = document.createElement("textarea");
      ta.value = text;
      ta.setAttribute("readonly", "");
      ta.style.position = "fixed";
      ta.style.left = "-9999px";
      document.body.appendChild(ta);
      ta.select();
      const ok = document.execCommand("copy");
      document.body.removeChild(ta);
      return ok;
    } catch (e) {
      return false;
    }
  }

  function closeOnlyThisPopup(popupRoot) {
    if (!popupRoot) return;

    // Nur innerhalb dieses Popups nach Close suchen (wichtig!)
    const closeBtn =
      popupRoot.querySelector('[aria-label*="close" i]') ||
      popupRoot.querySelector('[data-close]') ||
      popupRoot.querySelector(".close, .modal__close, .popup__close");

    if (closeBtn) {
      closeBtn.click();
      return;
    }

    // Fallback: Popup-Container verstecken (ohne die Seite zu beeinflussen)
    popupRoot.style.display = "none";

    // Falls ein Overlay existiert, das in popupRoot liegt
    const overlay = popupRoot.querySelector(".overlay, .backdrop, .modal-overlay");
    if (overlay) overlay.style.display = "none";
  }

  document.addEventListener("click", async function (e) {
    const target = e.target.closest("button, a");
    if (!target) return;

    if (!isCtaButton(target)) return;

    // Keine Navigation (keine Weiterleitung!)
    e.preventDefault();
    e.stopPropagation();

    // Popup-Root möglichst eng greifen:
    const popupRoot =
      target.closest('[role="dialog"]') ||
      target.closest(".modal") ||
      target.closest(".popup") ||
      target.closest(".overlay") ||
      target.closest("[class*='boomerang']");

    const coupon = findCouponInPopup(popupRoot) || fallbackCoupon;

    const ok = await copyToClipboard(coupon);

    // 2 Sekunden Feedback am Button
    const originalText = target.textContent;
    target.textContent = ok ? "✅ Rabattcode kopiert" : "⚠️ Kopieren nicht möglich";

    // Nach 2 Sekunden Popup schließen (und Buttontext zurück)
    setTimeout(() => {
      target.textContent = originalText;
      if (ok) closeOnlyThisPopup(popupRoot);
    }, 2000);
  });
})();
